import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import AuditConfirmationCriteria, { SummaryType } from "./AuditConfirmationCriteria";
import { Neo } from "@singularsystems/neo-react";
import { EnumHelper } from "@singularsystems/neo-core";

@NeoReport("AuditConfirmation", { hidden: true })
export default class AuditConfirmationReport extends Report<AuditConfirmationCriteria> {

    constructor() {
        super(AuditConfirmationCriteria);
    }

    public renderCriteria() {
        const criteria = this.criteria;
        return <div>
            
            <Neo.FormGroup bind={criteria.meta.type} select={{ items: EnumHelper.asList(SummaryType)}} />
            {criteria.type === SummaryType.Distributed &&
                <DateSelectionComponent criteria={this.criteria} />}
            {criteria.type === SummaryType.Accrued &&
                <Neo.FormGroup bind={criteria.meta.endDate} dateProps={{ alwaysShow: true, autoChangeDate: "end" }} />}
        </div>;
    }
}